<h1 mat-dialog-title>{{ title }}</h1>
<mat-dialog-content>
  <form [formGroup]="entityForm">
    <mat-tab-group animationDuration="0ms">
      <mat-tab [label]="'Generali' | translate">
        <div class="movement-general">
          <app-input-vocabulary-autocomplete
            formControlName="scopo"
            [vocabularyName]="'V_Movimento_scopo'"
            [placeholder]="'Scopo'">
          </app-input-vocabulary-autocomplete>
          <mat-form-field>
            <input
              matInput
              formControlName="descrizione"
              [placeholder]="'Descrizione'">
          </mat-form-field>
          <mat-form-field>
            <input
              matInput
              formControlName="dataUscita"
              mask="00/00/0000"
              [showMaskTyped]="true"
              [dropSpecialCharacters]="false"
              [placeholder]="'Data Uscita (dd/mm/aaaa)' | translate">
            <mat-error>Formato data non valido</mat-error>
          </mat-form-field>
          <mat-form-field>
            <input
              matInput
              formControlName="dataRientro"
              mask="00/00/0000"
              [showMaskTyped]="true"
              [dropSpecialCharacters]="false"
              [placeholder]="'Data Rientro (dd/mm/aaaa)' | translate">
            <mat-error>Formato data non valido</mat-error>
          </mat-form-field>
        </div>
      </mat-tab>
      <mat-tab [label]="'Allegati' | translate">
        <app-attachments-manager
          [form]="entityControls?.allegati"
          [classNames]="data.classNames || []">
        </app-attachments-manager>
      </mat-tab>
    </mat-tab-group>

    <div class="movement-actions">
      <button
        mat-button
        mat-raised-button
        type="submit"
        (click)="completeHandler()">
        {{ mainActionLabel }}
      </button>
    </div>
  </form>
</mat-dialog-content>
